exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".search[data-v-40713298]{-webkit-transition:0.3s all ease;-o-transition:0.3s all ease;transition:0.3s all ease;top:5px;right:5px;position:absolute}.search.open-search[data-v-40713298]{width:200px}.search.closed-search[data-v-40713298]{width:35px}@media screen and (min-width: 1350px){.search.closed-search[data-v-40713298]{width:200px}}\n", ""]);

// exports
